import { render, staticRenderFns } from "./kafa-form.vue?vue&type=template&id=60f3c0af&lang=pug"
import script from "./kafa-form.vue?vue&type=script&setup=true&lang=js"
export * from "./kafa-form.vue?vue&type=script&setup=true&lang=js"
import style0 from "@ui-common/vue-spinner/dist/vue-spinner.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports